enum Status {
    NEUTRAL = 'NEUTRAL',
    LOADING = 'LOADING',
    LOAD_SUCCESS = 'LOAD_SUCCESS',
    LOAD_ERROR = 'LOAD_ERROR',
    SAVING = 'SAVING',
    SAVE_SUCCESS = 'SAVE_SUCCESS',
    SAVE_ERROR = 'SAVE_ERROR',
    DELETING = 'DELETING',
    DELETE_SUCCESS = 'DELETE_SUCCESS',
    DELETE_ERROR = 'DELETE_ERROR'
}

export default Status;